import styled from "styled-components";
import { device } from "../../services/styles";

export const Row = styled.div`
  display: flex;
  position: relative;
  box-sizing: border-box;
  margin: 0 10px 40px 10px;
  flex-direction: column;
  width: 320px;
  border: ${(props) => (props.isAdvertising ? "2px solid #F1F1F1" : "none")};
  padding: ${(props) => (props.isAdvertising ? "4px" : "0")};

  cursor: pointer;
  @media ${device.tabletLarge} {
    flex-direction: row;
    width: 100%;
    margin: 0 0 40px 0;
    padding: ${(props) => (props.isAdvertising ? "30px 4px 4px 4px" : "0")};
  }
`;

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 320px;
  height: 180px;
  overflow: hidden;
  margin: 0 20px 5px 0;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
`;

export const Column = styled.div`
  display: block;
  width: 100%;
  @media ${device.tabletLarge} {
    width: calc(100% - 340px);
  }
`;

export const Title = styled.p`
  margin: 0 0 10px 0;
  font-size: 22px;
  line-height: 24px;
  color: #000;
  font-weight: 900;
  @media ${device.tabletLarge} {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const Lead = styled.p`
  margin: 0 0 10px 0;
  font-size: 16px;
  line-height: 24px;
  color: #000;
  height: 72px;
  overflow: hidden;
`;
export const Category = styled.span`
  display: block;
  position: absolute;
  top: 4px;
  left: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #4762ab;
  color: #fff;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  font-weight: 900;
`;

export const Date = styled.span`
  display: inline-block;
  align-self: flex-start;
  margin-bottom: 5px;
  padding: 1px 10px;
  border-radius: 4px;
  background-color: #f1f1f1;
  color: #000000;
  font-size: 14px;
  line-height: 18px;
`;

export const ReadMore = styled.span`
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #4762ab;
  @media ${device.tabletLarge} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Important = styled.span`
  display: inline-block;
  float: left;
  padding: 4px;
  margin-right: 5px;
  height: 24px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 900;
  background-color: #e6141b;
  color: #fff;
  @media ${device.desktop} {
    margin-top: 4px;
  }
`;

export const SpecialLabel = styled.span`
  position: relative;
  left: -4px;
  top: -4px;
  width: calc(100% + 8px);
  background-color: #f1f1f1;
  font-size: 12px;
  line-height: 16px;
  padding: 6px 10px 4px 10px;
  color: #000;
  @media ${device.tabletLarge} {
    position: absolute;
    z-intex: 10;
    width: 100%;
    left: 0;
    top: 0;
  }
`;

export const SitesLabel = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 4px;
  right: 4px;
  width: 64px;
  height: 32px;
  padding: 3px;
  background-color: #fff;
`;

export const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
